import { render, staticRenderFns } from "./platforms.vue?vue&type=template&id=5a47dead&"
import script from "./platforms.vue?vue&type=script&lang=js&"
export * from "./platforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports